export default __webpack_public_path__ + "static/media/interior (13).d7e72508.jpg";